import React from 'react'
import Image from 'next/image'
import { Header1, Text, Button } from '../styles/Components'
import styled from '@emotion/styled'
import { mq } from '../helpers'
import { gsColors } from '../styles/Variables'

const HeroWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0;

  .hero-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1600px;
    
    .hero-container-inner {
      width: 100%;
      height: 560px;
      display: flex;
      flex-direction: row;
      position: relative;

      ${mq('max', '768px')} {
        flex-direction: column;
        justify-content: center;
      }
      
      .content {
        width: ${props => props.fullWidth ? '100%' : '50%' };
        height: 100%;
        background-color: ${props => props.fullWidth ? 'transparent' : gsColors.cobalt};
        display: flex;
        justify-content: center;
        align-items: center;
        position: ${ props => props.fullWidth ? 'absolute' : 'initial' };
        z-index: 50;

        ${mq('max', '768px')} {
          width: 100%;
          height: auto;
          min-height: 400px;
        }
        
        .inner {
          margin: ${props => props.fullWidth ? 0 : '0 150px 0 88px'};
          text-align: ${props => props.fullWidth ? 'center' : 'left'};
          justify-content: center;
          align-items: ${props => props.fullWidth ? 'center' : 'flex-start'};
          display: flex;
          flex-direction: column;

          ${mq('max', '1290px')} {
            margin: 0px 40px;
          }
          
          ${mq('max', '768px')} {
            margin: 28px 16px;
          }

          .hero-button {
            margin-top: 55px;
            ${mq('max', '768px')} {
              margin-top: 10px;
            }
          }
          
          h1 {
            color: ${props => props.fullWidth ? gsColors.white : gsColors.salmon};
            text-align: ${props => props.fullWidth ? 'center' : 'left'};

            ${mq('max', '768px')} {
              margin-bottom: 8px !important;
              width: 60%;
            }
          }

          p {
            ${mq('max', '768px')} {
              line-height: 26.4px;
              width: 90%;
            }
          }
          
        }
        
      }
      
      .image-placeholder {
        height: 100%;
        background-color: #4D4D4D;
        position: relative;

        width: ${props => props.fullWidth ? '100%' : '50%'};

        ${mq('max', '768px')} {
          width: 100%;
          min-height: 500px !important;
        }
      }
    }
  }
`

/**
 * Universal Hero component
 * 
 * @param {string} header header text
 * @param {string} subheader subheader text
 * @param {string} image must use require— image={require('../../public/membership-hero.jpg')}
 * @param {string} imageAlt optional— descriptive alt text for the image (defaults to header)
 * @param {boolean} fullWidth determines if it's a full width header, or half and half with text/image
 * @param {*} content optional— a react element to pass into the content section
 * @param {string} className optional— passes a class name to the wrapper div for targeting outside of component
 * @returns 
 */
const Hero = ({ header,
  subheader,
  image,
  imageAlt,
  fullWidth = false,
  content,
  className = '',
  ctaClick,
  buttonTitle,
  hideCTA = true
}) => {
  return (
    <HeroWrapper fullWidth={fullWidth} className={className}>
      <div className="hero-container">
        <div className="hero-container-inner">
          <div className="content">
            <div className="inner">
              {content ? content : (
                <>
                  <Header1 margin="0 0 28px 0">{header}</Header1>
                  <Text fontSize={22} color="#FFF" lineHeight="138%">
                    {subheader}
                  </Text>
                  { !hideCTA && (
                    <Button
                      onClick={ctaClick}
                      large
                      color={gsColors.salmon}
                      style={{ color: gsColors.cobalt }}
                      className='hero-button'
                    >
                      {buttonTitle}
                    </Button>
                  )}
                </>
              )}
            </div>
          </div>
          <div className="image-placeholder">
            {image && <Image fill style={{ objectFit: 'cover' }} src={image} alt={imageAlt || header} priority quality={85} sizes={fullWidth ? '(max-width: 1600px) 100vw, 1600px' : '(max-width: 768px) 100vw, (max-width: 1600px) 50vw, 800px'} />}
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default Hero
